module.exports = __webpack_public_path__ + "static/media/70.8e9301de.svg";